export default __webpack_public_path__ + "static/media/DSC_8654-edited.61c8a26c.png";